
import { t } from "@/i18n";/* En-tête pendant la séance : montre quel exercice est en cours et sa
   progression, pas juste un pourcentage global illisible.
   - Mobile : segments façon "story" (TikTok/Instagram), un par exercice.
   - Desktop : breadcrumb d'icônes numérotées avec coche sur les terminés. */
export default function DailyPlanHeader({ items, currentIdx, itemsProgress }) {
  return (
    <div className="mb-4">
      {/* Mobile : segments façon story */}
      <div className="flex gap-1 md:hidden">
        {items.map((_, i) => (
          <div
            key={i}
            className="h-1.5 flex-1 rounded-full bg-secondary overflow-hidden"
          >
            <div
              className="h-full bg-primary transition-all duration-500"
              style={{
                width: itemsProgress[i]
                  ? "100%"
                  : i === currentIdx
                    ? "50%"
                    : "0%",
              }}
            />
          </div>
        ))}
      </div>
      {/* Desktop : breadcrumb d'icônes */}
      <div className="hidden md:flex items-center gap-2">
        {items.map((it, i) => (
          <div key={i} className="flex items-center gap-2">
            <div
              className={`w-8 h-8 rounded-full grid place-items-center text-xs font-bold border-2 ${
                itemsProgress[i]
                  ? "bg-emerald-500 border-emerald-500 text-white"
                  : i === currentIdx
                    ? "border-primary text-primary"
                    : "border-border text-muted-foreground"
              }`}
            >
              {itemsProgress[i] ? "✓" : i + 1}
            </div>
            {i < items.length - 1 && <div className="w-8 h-0.5 bg-border" />}
          </div>
        ))}
      </div>
      <div className="text-xs text-muted-foreground mt-2 text-center md:text-left">
        {t("dailyplanheader.etape")} {currentIdx + 1} / {items.length} — {items[currentIdx]?.label_fr}
      </div>
    </div>
  );
}
